/** @format */

import React, { useState, useEffect } from 'react';

import { Spin, Row, Col, Input, Button } from 'antd';

import List from './components/List';
import { useLocation, useHistory } from 'react-router-dom';
import { serviceCriterionQf } from './services';
import { handleSearchParams } from './handle/search-params.handle';
import CustomPagination from '../../v2-components/Antd/Pagination';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';

import './style.css';

export default function QfCriterionV2(props) { //TODO REFACTOR
	const [loading, setLoading] = useState(true);
	const [paginationResponse, setPaginationResponse] = useState();
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const [criterionQf, setCriterionQf] = useState({ data: [] });
	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const page = searchParams.get('page');
	const [filters, setFilters] = useState({
		rut: '',
		code_internal: '',
	});

	useEffect(() => {
		let mounted = true;
		(async () => {
			setLoading(true);
			let response = await serviceCriterionQf({ rut: '', code_internal: '', pharmacy, page });
			if (!mounted) return;
			setCriterionQf(response);
			setPaginationResponse(response);
			setLoading(false);
		})();

		return () => (mounted = false);
	}, [pharmacy, page]);

	const handleFilters = (item, field) => {
		setFilters((pvSt) => ({
			...pvSt,
			[field]: item,
		}));
	};

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleSearchFilters = async () => {
		let response = await serviceCriterionQf({ ...filters, pharmacy });
		setCriterionQf(response);
	};

	if (loading) {
		return (
			<div className="ph-amp-spinner-container">
				<Spin size="large" />
			</div>
		);
	}
	return (
		<div className="ph-tracking-list-title-container">
			<Row >
				<Col span={12}>
					<h1 className="ph-ampp-list-main-title-tracking">Historial de Aprobaciones bajo el criterio del Farmaceútico</h1>
				</Col>

				<Col>
					<Input
						className="ph-qf-criterion-input-filters"
						placeholder="Identificación del Cliente"
						onChange={(rut) => handleFilters(rut.target.value, 'rut')}
					/>
				</Col>
				<Col>
					<Input
						className="ph-qf-criterion-input-filters"
						placeholder="Código Internal del producto"
						onChange={(code) => handleFilters(code.target.value, 'code_internal')}
					/>
				</Col>
				<Col>
					<Button type="primary" onClick={handleSearchFilters}>
						Filtrar
					</Button>
				</Col>
			</Row>
			<div className="ph-complaint-book-main-container">
				<List criterionQf={criterionQf.data} />

				<CustomPagination
					onChange={handlePageChange}
					total={paginationResponse?.totalItems}
					current={page}
					pageSize={paginationResponse?.itemsPerPage}
				/>
			</div>
		</div>
	);
}
